export const tyreCarVehicleTypesGroup = ['car', 'offRoad', 'lightTruck'];
export const tyreAllAvailableVehicleTypes = ['car', 'lightTruck', 'bike', 'truck', 'offRoad'];